import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { Fragment as external_react_Fragment, useEffect, useRef, useState } from "react";
import { Box } from "../Box/index.js";
import { Link } from "../Link/index.js";
import { Typography } from "../Typography/index.js";
const TruncatedText = (t0)=>{
    const $ = c(19);
    const { text, alwaysShowButton: t1, children, rows: t2, textVariant: t3, color: t4, buttonVariant, buttonPadding: t5, wordBreak } = t0;
    const alwaysShowButton = void 0 === t1 ? false : t1;
    const rows = void 0 === t2 ? 10 : t2;
    const textVariant = void 0 === t3 ? "body2" : t3;
    const color = void 0 === t4 ? "text.light.primary" : t4;
    const buttonPadding = void 0 === t5 ? "8" : t5;
    const maxHeight = 24 * rows;
    const [isTruncated, setIsTruncated] = useState(true);
    const [textHeight, setTextHeight] = useState(0);
    const textRef = useRef(null);
    const showButton = alwaysShowButton || textHeight > maxHeight;
    let t6;
    let t7;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            if (textRef.current) setTextHeight(textRef.current.clientHeight);
        };
        t7 = [];
        $[0] = t6;
        $[1] = t7;
    } else {
        t6 = $[0];
        t7 = $[1];
    }
    useEffect(t6, t7);
    let t8;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>setIsTruncated(_temp);
        $[2] = t8;
    } else t8 = $[2];
    const toggleVisibility = t8;
    let t9;
    if ($[3] !== color || $[4] !== isTruncated || $[5] !== maxHeight || $[6] !== text || $[7] !== textVariant || $[8] !== wordBreak) {
        t9 = text && /*#__PURE__*/ jsx(Box, {
            overflow: isTruncated ? "hidden" : "visible",
            maxHeight: isTruncated ? maxHeight : "none",
            testId: "truncated-text-test-id",
            children: /*#__PURE__*/ jsx("div", {
                ref: textRef,
                children: /*#__PURE__*/ jsx(Typography, {
                    variant: textVariant,
                    color: color,
                    wordBreak: wordBreak,
                    children: text.split("\n").map(_temp2)
                })
            })
        });
        $[3] = color;
        $[4] = isTruncated;
        $[5] = maxHeight;
        $[6] = text;
        $[7] = textVariant;
        $[8] = wordBreak;
        $[9] = t9;
    } else t9 = $[9];
    const t10 = !isTruncated && children;
    let t11;
    if ($[10] !== buttonPadding || $[11] !== buttonVariant || $[12] !== isTruncated || $[13] !== showButton) {
        t11 = showButton && /*#__PURE__*/ jsx(Box, {
            pt: buttonPadding,
            children: /*#__PURE__*/ jsx(Link, {
                stroke: false,
                onClick: toggleVisibility,
                variant: buttonVariant,
                children: isTruncated ? "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0435\u0449\u0435" : "\u0421\u043A\u0440\u044B\u0442\u044C"
            })
        });
        $[10] = buttonPadding;
        $[11] = buttonVariant;
        $[12] = isTruncated;
        $[13] = showButton;
        $[14] = t11;
    } else t11 = $[14];
    let t12;
    if ($[15] !== t10 || $[16] !== t11 || $[17] !== t9) {
        t12 = /*#__PURE__*/ jsxs(Fragment, {
            children: [
                t9,
                t10,
                t11
            ]
        });
        $[15] = t10;
        $[16] = t11;
        $[17] = t9;
        $[18] = t12;
    } else t12 = $[18];
    return t12;
};
function _temp(prev) {
    return !prev;
}
function _temp2(paragraph) {
    return /*#__PURE__*/ jsxs(external_react_Fragment, {
        children: [
            paragraph,
            /*#__PURE__*/ jsx("br", {})
        ]
    }, paragraph);
}
export { TruncatedText };
